export default "__VITE_ASSET__CzVcZCXZ__"